import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import CredentialsStore from '../store/credentials-store'
import { Cabinet } from '../interfaces/interfaces'
//import '@microsoft/office-js/dist/office'


@Component({ store: CredentialsStore })
export default class SettingsMixin extends Vue
{
  cabinetsRoamingKey = 'lysias5-mail-cabinets';

  loadCabinets()
  {
    const settingValue: Cabinet[] = Office.context.roamingSettings.get(this.cabinetsRoamingKey);
    if(settingValue !== null && settingValue !== undefined)
    {
        console.log(this.$store.state.cabinets);
        let nextId = 1;
        const cabinets = settingValue.map((item, index) => {
          if (item.id === null) {
            item.id = nextId++;
          }
          return item;
        });
        this.$store.commit('setCabinets', cabinets);
    }

  }

  saveCabinets()
  {
    Office.context.roamingSettings.set(this.cabinetsRoamingKey, this.$store.state.cabinets);
    Office.context.roamingSettings.saveAsync((result: Office.AsyncResult<void>) => {
      console.log(result);
    });
  }

  get hasAttachToMultipleDossiersCapability()
  {
    try
    {
      return this.$store.state.capabilities.includes('mail_attach_multiple_dossiers');
    }
    catch(e)
    {
      console.error(e);
      return false;
    }
  }

}
